<template>
<div>
        <!-- HEADER TITULO -->
        <div class="titulo-contenido">
            <h1>
                <span class="negrita">RENDICIÓN DE CUENTAS</span>
            </h1>
        </div>
        <!--  -->
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                                <cardsMenu titulo="Leyes" descripcion="Información relevante sobre las leyes aplicables." esIcono="true" recurso="fa fa-balance-scale"/>
                </div>
                <div class="col-md-6">
                                <cardsMenu titulo="Leyes"  descripcion="Información relevante sobre las leyes aplicables." esIcono="true" recurso="fa fa-balance-scale"/>
                </div>
                <div class="col-md-12">
                                <cardsArray :cards="cardsArray"/>
                </div>
                <div class="col-md-6">
                    <imagenComponent imgSrc="leyesMunicipal.jpg" imgAlt="Hola"/>
                </div>
                <div class="col-md-6">
                    <p>Link componente</p>
                    <document-component :link="urlServe+'marco-juridico/Municipal/informacion/Leyes/Desarrollo-Mpal.pdf'" titulo="Ley de Desarrollo Constitucional en Materia de Gobierno y Administración Municipal del Estado de Chiapas"/>
                </div>
                <div class="col-md-6">
                    <select-ejercicio :options="yearOptions" labelTitle="Categoria" labelDescription="Selecciona el objeto a consultar" placeholder="Consultar año" buttonText="Buscar" resultTitle="Testing" :loading="loading" :optionToShow="yearToShow" @optionSelected="handleYearSelected" />
                </div>
                <div class="col-md-12">
                    <card-collapse :sections="sectionData" :urlServe="urlServe"/>
                </div>
                <div class="col-md-6">
                    <card-collapse-docs :sections="sectionDataDos" :urlServe="urlServe" />
                </div>
                <div class="col-md-12">
                  <table-section :sections="sectionsTable" :urlServe="urlServe" />
                </div>
            </div>
        </div>
</div>
</template>
<script>
import cardsMenu from '../components/cardsMenu.vue';
import imagenComponent from '../components/imagenComponent.vue';
import documentComponent from '../components/documentComponent.vue';
import selectEjercicio from '../components/selectEjercicio.vue';
import cardCollapse from '../components/cardCollapse.vue';
import cardsArray from '../components/cardsArray.vue';
import cardCollapseDocs from '../components/cardCollapseDocs.vue';
import tableSection from '../components/table.vue';
export default {
  components: { cardCollapseDocs, cardsMenu, cardsArray, imagenComponent, tableSection , documentComponent, selectEjercicio, cardCollapse },
   data(){
    return {
      // cardsArray
            cardsArray: [
        { titulo: 'Card 1', esIcono:true, descripcion: 'descripcion 1', recurso:'fa fa-balance-scale' },
        { titulo: 'Card 2', esIcono:true, descripcion: 'descripcion 2', recurso:'fa fa-user' },
        { titulo: 'Card 3', esIcono:false, descripcion: 'descripcion 3', recurso: 'img/rendicion-ctas/Presupuesto-egresos.jpg' }
      ],
      // select
         yearOptions: [
        { value: 2002, label: '2002' },
        { value: 2003, label: '2003' },
        { value: 2004, label: '2004' },
        { value: 2024, label: '2024' }
      ],
      categoryOptions: [
        { value: 'tech', label: 'Tecnología' },
        { value: 'health', label: 'Salud' },
        { value: 'finance', label: 'Finanzas' }
      ],
      loading: false,
      yearToShow: null,
      categoryToShow: null,
    //   card collapse
      urlServe: 'https://ejemplo.com/files/',
      sectionData: [
        {
          titulo: 'Anexos',
          contenido: [
            { titulo: 'Anexo 1', url_pdf: 'anexos/Anexo1.pdf' },
            { titulo: 'Anexo 2', url_pdf: 'anexos/Anexo2.pdf' }
          ]
        },
        {
          titulo: 'Documentos Legales',
          contenido: [
            { titulo: 'Contrato 1', url_pdf: 'documentos/Contrato1.pdf' },
            { titulo: 'Contrato 2', url_pdf: 'documentos/Contrato2.pdf' }
          ]
        },
        {
          titulo: 'Guías Técnicas',
          contenido: [
            { titulo: 'Guía Técnica 1', url_pdf: 'guias/Guia1.pdf' },
            { titulo: 'Guía Técnica 2', url_pdf: 'guias/Guia2.pdf' }
          ]
        }
      ],
      sectionDataDos: [
  {
    titulo: 'Sección 1',
    contenido: [
      { 
        titulo: 'Documento 1', 
        url_pdf: '/path-to-file1.pdf',
        url_word: '/path-to-file1.docx',
        url_excel: '/path-to-file1.xlsx',
        url_comprimido: '/path-to-file1.rar',
      },
      { 
        titulo: 'Documento 2', 
        url_pdf: null, // No mostrará icono de PDF
        url_word: '/path-to-file2.docx',
        url_excel: '/path-to-file2.xlsx',
        url_comprimido: null, // No mostrará icono de RAR
      },
    ],
  },
  // Más secciones...
],
    sectionsTable: [
        {
          titulo: "Sección 1",
          contenido: [
            {
              titulo: "Documento 1",
              url_pdf: "documento1.pdf", // Solo tiene PDF
              url_word: null,
              url_excel: "documento3.xlsx", // Solo tiene Excel
              url_comprimido: null
            },
            {
              titulo: "Documento 2",
              url_pdf: "documento4.pdf", // Tiene varios documentos
              url_word: "documento4.docx",
              url_excel: null,
              url_comprimido: "documento4.zip"
            }
          ]
        }
      ]


    }
   },
   methods:{
     handleYearSelected(selectedYear) {
      this.yearToShow = selectedYear;
      this.loading = true;
      // Simula la carga o realiza la consulta
      setTimeout(() => {
        this.loading = false;
      }, 2000); // Ajusta el tiempo según tu lógica de consulta
    },
    handleCategorySelected(selectedCategory){
        this.categoryToShow = selectedCategory;
        this.loading = true;
        setTimeout(()=>{
            this.loading = false;
        }, 2000)
    }
   }
}
</script>
